module.exports = __webpack_public_path__ + "static/media/93gal12.f4eca760.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/93gal/93gal12.jpg
// module id = 311
// module chunks = 0